import { map as _map } from 'lodash-es';
import { useMemo, Fragment } from 'react';
import MLink from '@mui/material/Link';
import SelectField from './select-field';
import { licenses } from '../../utils/licenses';

type Props = {
  name: string;
  [key: string]: unknown;
};

const LicenseField = ({ name, ...props }: Props) => {
  const options = useMemo(() => _map(licenses, ({ label }, value) => ({ value, label })), []);

  return (
    <SelectField
      name={name}
      {...props}
      options={options}
      helperText={(
        <Fragment>
          Learn about
          {' '}
          <MLink href="https://creativecommons.org/licenses/" target="_blank">
            Creative Commons Licenses
          </MLink>
        </Fragment>
      )}
    />
  );
};

export default LicenseField;
